/**
 * Copyright 2015-present Isshoikka. All Rights Reserved.
 *
 */

const Dispatcher = require('flux').Dispatcher;
const IsshoikkaDispatcher = new Dispatcher();

export default IsshoikkaDispatcher;
